import Highcharts from "highcharts";
import uggHighchartsTheme from "./themes/ugitgud";

export function initHighcharts() {
  // Highcharts.theme = uggHighchartsTheme;
  Highcharts.setOptions(uggHighchartsTheme);
}
